import { createTheme } from '@mui/material/styles'

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#163A5F',
      light: '#295C8A',
      dark: '#0D2740',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#2F80ED',
    },
    background: {
      default: '#F3F6F9',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#172B4D',
      secondary: '#667085',
    },
    divider: '#E4E7EC',
  },
  typography: {
    fontFamily: '"Montserrat", sans-serif',
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#163A5F',
          boxShadow: '0 1px 3px rgba(16, 24, 40, 0.12)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 6,
        },
      },
    },
  },
})

export default theme